import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { TEXT } from '../../../Constants/WidgetTypes';
import CustomFilterModal from '../../CustomFilterModal';
import subDays from 'date-fns/subDays';
import isValid from 'date-fns/isValid';

const MAX_DATAPOINTS = 3000;
export default function CustomTimeFilterModal(props) {
  const {
    customEndTimestamp,
    customStartTimestamp,
    type,
    maxDatapoints,
    showCustomFilterModal,
    handleCustomFilterSaveCallback,
    toggleCustomFilterModal,
  } = props;

  const handleCustomFilterSave = useCallback(
    ({ endDate, maxDatapoints, startDate }) => {
      const end = new Date(endDate),
        customEndTimestamp = isValid(end) ? end.getTime() : Date.now(),
        start = new Date(startDate),
        customStartTimestamp = isValid(start)
          ? start.getTime()
          : subDays(customEndTimestamp, 7);
      handleCustomFilterSaveCallback({
        customEndTimestamp,
        maxDatapoints,
        customStartTimestamp,
      });
    },
    [handleCustomFilterSaveCallback]
  );

  return (
    <CustomFilterModal
      customEndTimestamp={customEndTimestamp}
      customStartTimestamp={customStartTimestamp}
      globalMaxDatapoints={MAX_DATAPOINTS}
      handleCustomFilterSave={handleCustomFilterSave}
      isOpen={showCustomFilterModal}
      isTextTile={type === TEXT}
      maxDatapoints={maxDatapoints || MAX_DATAPOINTS}
      toggleModal={toggleCustomFilterModal}
    />
  );
}

CustomTimeFilterModal.propTypes = {
  customEndTimestamp: PropTypes.number,
  customStartTimestamp: PropTypes.number,
  type: PropTypes.string,
  maxDatapoints: PropTypes.number,
  showCustomFilterModal: PropTypes.bool,
  handleCustomFilterSaveCallback: PropTypes.func,
  toggleCustomFilterModal: PropTypes.func,
};
